export const track = (event, properties) => {
    if (window._paq === undefined) {
        console.warn('Analytics not initialized - windows._paq is undefined');
        window._paq = [];
    }
    window._paq.push([event, properties]);
};
export const trackCustomDimension = (index, value) => {
    if (window._paq === undefined) {
        console.warn('Analytics not initialized - windows._paq is undefined');
        window._paq = [];
    }
    window._paq.push(['setCustomDimension', index, value]);
};
export const scanForForms = (element) => {
    track('FormAnalytics::scanForForms', element);
};
export const trackFormConversion = (name) => {
    track('FormAnalytics::trackFormConversion', name);
};
export const trackUserSession = (session) => {
    if (session === null) {
        return;
    }
    trackCustomDimension(1, session.user._.key);
    trackCustomDimension(2, session.organization.name);
    trackCustomDimension(3, session.organization.domain === 'internal' ? 'Yes' : 'No');
    trackCustomDimension(4, session.user.email);
    trackCustomDimension(5, `${session.user.name.first} ${session.user.name.last}`);
};
